export default __webpack_public_path__ + "static/media/Eina01-SemiBold.2ffa1acb.woff";